export default "__VITE_ASSET__DEouOBnG__"